import { PositionType, TUserOrderType } from '@features/userPanel/typescript';
export const getReturnableOrderPositions = (order: TUserOrderType): Array<PositionType> => order.positions.filter(position => position.type === 'product');